import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapSingle } from '../../ruutsApi/normalize'

export type PerimeterPreconditions = {
  result: boolean
  reason: string | null
}

export const validatePerimeterPreconditions = async ({
  id,
  overrideEdition,
  signal,
}: {
  id: string
  overrideEdition: boolean
  signal?: AbortSignal
}): Promise<PerimeterPreconditions> => {
  const response = await apiClient.get(
    `${endpoints.farms}/${id}/validate/preconditions?overrideEdition=${overrideEdition}`,
    { signal },
  )
  return unwrapSingle<PerimeterPreconditions>(response)
}
